<template>
    <el-drawer
        title="学员签到情况"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-form ref="form" :model="form" label-width="80px" class="edit_form">
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" suffix-icon="el-icon-search" style="width: 340px;margin-right: 20px"></el-input>
                </el-form-item>
            </el-form>

            <el-table
                ref="userTable"
                :data="showList"
                stripe
                style="width: 100%"
            >
                <el-table-column
                    min-width="120"
                    prop="name"
                    label="学生姓名" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="sn"
                    label="编号" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="签到情况" >
                    <template slot-scope="scope">
                        <i v-if="scope.row.isAttendance == false"  class="iconfont icon-suoxiao text_ligher font20" ></i>
                        <i v-else  class="iconfont icon-duihao text_primary font20"></i>

                    </template>
                </el-table-column>
            </el-table>

        </div>
        <span  class="fx fx-center">
            <el-button @click="close()">关闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .el-table {
        overflow-y: scroll;
        overflow: auto;
    }
</style>


<script>


    export default {
        props: [
            "classid",
        ],
        data() {
            return {
                show: false,
                form: {keywords: ""},
                tableData:[],
            }

        },
        computed: {
            showList: function () {
                if (this.form.keywords) {
                    let keywords =this.form.keywords;
                    return this.tableData.filter(item => (item.name.indexOf(keywords) > -1 || item.sn.indexOf(keywords) > -1));
                } else {
                    return this.tableData;
                }
            }
        },

        methods: {
            close() {
                this.$emit("close");
            },
            sub() {
                let data = this.form;
                this.$ajaxPost("/plateformVersion/save", {
                    plateformVersion: data
                }, (data) => {
                    this.$emit("submit", data.result);
                })
                return false;
            },
            loadData() {
                this.$ajaxGet("/classLesson/listStudentAttendanceInfo/" + this.classid, data=> {
                    data.result.sort((a, b) => {
                        let p = a.isAttendance ? 1 : 0;
                        let q = b.isAttendance ? 1 : 0;
                        return q - p;
                    })
                    this.tableData = data.result;
                })
            }
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadData();
        }


    }
</script>
